<div app-landing-page-section-container class="items-center">
    <div class="mat-headline-6 lg:w-[900px] text-center pb-4" translate>
        LandingPageBookingTitle
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 mt-4 md:mt-8 lg:px-8 gap-8">
        @for (useCase of useCases; track useCase) {
            <div class="bg-white rounded-2xl flex flex-col p-8">
                <div class="flex flex-row items-center h-16 mb-4">
                    <mat-icon
                        svgIcon="{{ useCase.icon }}"
                        class="flex-none w-8 h-8"
                    ></mat-icon>
                    <div class="mat-subtitle-2 pl-4">
                        {{ useCase.title | translate }}
                    </div>
                </div>

                <p class="mat-body-1 m-0">
                    {{ useCase.description | translate }}
                </p>
            </div>
        }
    </div>
</div>
